import { Skeleton as AntDSkeleton } from 'antd';

import { useResponsive } from '../../hooks/useResponsive';
import {
  StyledBottomContainer,
  StyledCenterBottomContainer,
  StyledContainer,
  StyledFlexWrapperWithGap,
  StyledFullScreenWrapper,
  StyledTopContainer,
  StyledWrapper,
} from './LayoutSkeleton.styles';

const Skeleton = ({ width }: { width?: number }) => (
  <StyledWrapper width={width}>
    <AntDSkeleton.Node active />
  </StyledWrapper>
);

export function LayoutSkeleton() {
  const { isDesktop } = useResponsive();

  if (!isDesktop) {
    return (
      <StyledContainer>
        <StyledTopContainer>
          <Skeleton width={120} />
          <Skeleton width={100} />
        </StyledTopContainer>

        <StyledFullScreenWrapper>
          <Skeleton />
        </StyledFullScreenWrapper>

        <StyledCenterBottomContainer>
          <Skeleton width={70} />
        </StyledCenterBottomContainer>

        <StyledBottomContainer>
          <Skeleton width={45} />
        </StyledBottomContainer>
      </StyledContainer>
    );
  }

  return (
    <StyledContainer>
      <StyledTopContainer>
        <Skeleton width={269} />

        <Skeleton width={80} />
      </StyledTopContainer>

      <StyledFullScreenWrapper>
        <Skeleton />
      </StyledFullScreenWrapper>

      <StyledBottomContainer>
        <StyledFlexWrapperWithGap>
          <Skeleton width={45} />
          <Skeleton width={150} />
        </StyledFlexWrapperWithGap>

        <StyledFlexWrapperWithGap>
          <Skeleton width={200} />
          <Skeleton width={150} />
        </StyledFlexWrapperWithGap>
      </StyledBottomContainer>
    </StyledContainer>
  );
}
